<div
    class="cmps-coaching-detail--pillar-one"
    [class.cmps-coaching-detail--pillar-one-left]="_pillarOneCollapsible"
    [class.cmps-coaching-detail--pillar-one-open]="_open"
>
    <cmps-scrollbar class="cmps-coaching-detail--pillar-one--scrollbar">
        <cmps-coaching-detail-pillar-one></cmps-coaching-detail-pillar-one>
    </cmps-scrollbar>

    <div
        class="cmps-coaching-detail--pillar-one--toggle"
        *ngIf="_pillarOneCollapsible"
    >
        <button
            class="cmps-icon-button--no-bg"
            cmpsIconButton
            (click)="_onPillarOneToggleClick()"
        >
            <cmps-icon
                [svgIcon]="_open ? 'menu-left' : 'menu-right'"
            ></cmps-icon>
        </button>
    </div>
</div>

<div class="cmps-coaching-detail--pillar-two">
    <cmps-coaching-detail-pillar-two
        [pillarOneCollapsible]="_pillarOneCollapsible"
    ></cmps-coaching-detail-pillar-two>
</div>

<div class="cmps-coaching-detail--pillar-three">
    <router-outlet></router-outlet>
</div>
